import { useAppSelector } from '@frontend/common';
import { TransactionCountConstraintData, isTransactionCountConstraintData } from '@frontend/constraint/types';
import { formStore, updateField } from '@frontend/repository';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { TransactionCountConstraintDataInputProps } from './transaction-count-constraint-data-input.component';

interface ViewProps {
    formValues: TransactionCountConstraintData;
}

const useTransactionCountConstraintDataInput = (props: TransactionCountConstraintDataInputProps): ViewProps => {
    const store = useAppSelector(useSelector, formStore);
    const formValues = store[props.formId]?.value['data'];

    useEffect(() => {
        if (!isTransactionCountConstraintData(store[props.formId]?.value['data'])) {
            props.dispatch(updateField({ formId: props.formId, key: 'data', value: { quantity: 1 } }));
        }
    }, []);

    return {
        formValues
    };
};

export default useTransactionCountConstraintDataInput;
